import React, { useState } from 'react'
import services from '../constants/services.json'
import { lightTheme } from '../assets/styles/theme';
import { Button, MenuItem, Paper, ScopedCssBaseline, TextField, ThemeProvider, Typography } from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment';
import PersonIcon from '@mui/icons-material/Person';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';
// import CommentIcon from '@mui/icons-material/Comment';
import SendIcon from '@mui/icons-material/Send';
import useTheme from '@mui/material/styles/useTheme';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
// import FormControl from '@mui/material/FormControl';
// import FormLabel from '@mui/material/FormLabel';
// import RadioGroup from '@mui/material/RadioGroup';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Radio from '@mui/material/Radio';

const ContactFormId = "contact-form"

function ContactForm(
  props: {
    title?: string, clientType?:"Hogar"|"Empresa", serviceSelected?:string,
    flat?: boolean, onDialog?:boolean,
    sended?: boolean, setConfirmed?:(sended:boolean)=>void
  }
) {
  const {title, flat, onDialog} = {...props}
  const theme = useTheme()
  // let allservices:string[] = [];
  // services.forEach( s =>{
  //   if (s.subservices)
  //   s.subservices.forEach( ss => allservices.push(ss.title) )
  //   else 
  //   allservices.push(s.title)
  // } )
  
  const getServByValue = (value:string) => services.find((s)=>s.title === value) ?? services[0]
  const [serviceSelected, setServiceSelected] = useState( getServByValue(props.serviceSelected??'') )
  const defualtInput = { value:"", error:false }
  const defaultContact = {
    // clientType: props.clientType??"Empresa",
    fullname: defualtInput,
    phone: defualtInput,
    email: defualtInput,
    service: serviceSelected.title,
    subservice: serviceSelected.subservices?.at(0)?.title,
    info: defualtInput,
  }
  const checkMinLen = (txt:string, nmin:number) => txt !== "" && txt.length < nmin
  const [answersVal, setAnswersVal] = useState(defaultContact);
  const handleForm = {
    // clientType:(event:React.ChangeEvent<HTMLInputElement>)=>{
    //   let newVal = event.target.value
    //   if (newVal === "Hogar" || newVal === "Empresa")
    //     setAnswersVal({...answersVal, clientType: newVal})
    // },
    fullname: (event:React.ChangeEvent<HTMLInputElement>)=>{
      let newVal = event.target.value
      let error = checkMinLen(newVal, 5)
      setAnswersVal({...answersVal, fullname: {error:error, value:newVal }})
    },
    phone: (event:React.ChangeEvent<HTMLInputElement>)=>{
      let newVal = event.target.value
      let error = checkMinLen(newVal, 9) && !newVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)
      setAnswersVal({...answersVal, phone: {error:error, value:newVal }})
    },
    email: (event:React.ChangeEvent<HTMLInputElement>)=>{
      let newVal = event.target.value
      let error = checkMinLen(newVal, 6)
      setAnswersVal({...answersVal, email: {error:error, value:newVal }})
    },
    service: (event: React.ChangeEvent<HTMLInputElement>) => {
      const newServ = getServByValue(event.target.value)
      setServiceSelected( newServ );
      setAnswersVal( {
        ...answersVal,
        service:newServ.title,
        subservice:newServ.subservices?.at(0)?.title
      } )
    },
    subservice: (event: React.ChangeEvent<HTMLInputElement>)=>{
      setAnswersVal({...answersVal, subservice:event.target.value})
    },
    info: (event:React.ChangeEvent<HTMLTextAreaElement>)=>{
      let newVal = event.target.value
      let error = checkMinLen(newVal, 10)
      if(event.target.value.length <= 300) {
        setAnswersVal({...answersVal, info: { error:error, value:newVal }})
      }
    },
  }

  const sendAlertOpts = [
    { title: "Mensaje enviado", message: "Nos pondremos en contacto con ud. a la brevedad posible." },
    { title: "Campos no válidos", message: "Por favor, corregir antes de enviar el formulario." },
  ]
  const [sendAlert, setSendAlert] = useState( sendAlertOpts[0] )
  const [sended, setSended] = React.useState(false);
  const handleSubmit = () => {
    if ((answersVal.fullname.error || answersVal.email.error || answersVal.info.error))
      setSendAlert(sendAlertOpts[1])
    else
      setSendAlert(sendAlertOpts[0])
    setSended(true)
  }
  React.useEffect(()=>{
    if (props.sended) { handleSubmit() }
  }, [props.sended])
  const handleClose = () => {
    setSended(false)
    setAnswersVal({...answersVal, info: defualtInput});
    if(props.setConfirmed !== undefined) props.setConfirmed(true)
  };


  return (
  <ThemeProvider theme={flat? theme : lightTheme}>
    <ScopedCssBaseline>
      <Paper
        sx={{px:4, py:3, display:'flex', flexDirection:'column', gap:'1.5em'}}
        elevation={flat ? 0 : 2}
        component="form"
        id={ContactFormId}
        action={(answersVal.fullname.error || answersVal.email.error || answersVal.info.error)?"":"https://docs.google.com/forms/d/e/1FAIpQLSdqMYKUrOabN8t4L7FE8NuWbWPdFvIUOxaJRgH2rjE_SmtpHQ/formResponse"}
        target="response"
        method="POST"
        onSubmit={handleSubmit}
      >
        <iframe name='response' hidden/>
        
        {!onDialog ?
        <Typography variant='h5' component='legend' textAlign="center">
          {title}
        </Typography>
        : ''}


        {/* <FormControl>
          <FormLabel id="client-type">Cliente</FormLabel>
          <RadioGroup row
            aria-labelledby="client-type"
            defaultValue="Hogar"
            value={answersVal.clientType}
            onChange={handleForm.clientType}
            name="entry."
          >
            <FormControlLabel value="Empresa" control={<Radio />} label="Empresa" />
            <FormControlLabel value="Hogar" control={<Radio />} label="Hogar" />
          </RadioGroup>
        </FormControl> */}


        <TextField
          required
          variant="standard"
          className={"conn" + (answersVal.fullname.error?" whelper":"")}
          label="Nombres y apellidos"
          // defaultValue="nombre"
          value={answersVal.fullname.value}
          onChange={handleForm.fullname}
          error={answersVal.fullname.error}
          helperText={answersVal.fullname.error?"Por favor escribir una respuesta válida":""}
          type="text"
          name="entry.1169010483"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"> <PersonIcon /> </InputAdornment>
            ),
          }}
        />

        <TextField
          className="conn whelper"
          variant="standard"
          label="Celular"
          // defaultValue="9999"
          value={answersVal.phone.value}
          onChange={handleForm.phone}
          error={answersVal.phone.error}
          helperText={answersVal.phone.error?"Solo son válidos números, espacios y ()-":"Ejemplo: 01 999 999 999"}
          type="tel"
          name="entry.1215857143"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"> <SmartphoneIcon /> </InputAdornment>
            ),
          }}
        />

        <TextField
          required
          variant="standard"
          className="conn whelper"
          label="Correo electrónico"
          // defaultValue="correo@gmail.com"
          value={answersVal.email.value}
          onChange={handleForm.email}
          error={answersVal.email.error}
          helperText={answersVal.email.error?"Colocar correo válido":"Ejemplo: ejemplo@correo.com"}
          type="email"
          name="entry.33683583"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"> <EmailIcon /> </InputAdornment>
            ),
          }}
        />

        <TextField
          required
          variant="standard"
          className="conn"
          label="Servicio de interés"
          value = {answersVal.service}
          onChange = {handleForm.service}
          select
          name="entry.738593999"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start"> <ElectricalServicesIcon /> </InputAdornment>
            ),
          }}
        >
          {services.map((s, i) => (
            <MenuItem key={i} value={s.title}>{s.title}</MenuItem>
          ))}
        </TextField>

        {
          serviceSelected.subservices ?
          <TextField
            variant="standard"
            className="conn"
            label="Tipo de Servicio"
            defaultValue={ answersVal.subservice }
            onChange={ handleForm.subservice }
            select
            name="entry.2054921743"
          >
            {serviceSelected.subservices.map((s, i) => (
              <MenuItem key={i} value={s.title}>{s.title}</MenuItem>
            ))}
          </TextField>
          :''
        }
        
        <TextField
          required
          variant="standard"
          className="conn whelper"
          label="Información adicional"
          // defaultValue="Lorem ipsum"
          value={answersVal.info.value}
          onChange={handleForm.info}
          error={answersVal.info.error}
          helperText={ answersVal.info.error?"Escrbir al menos 10 caracteres" : `${answersVal.info.value.length} / 300` }
          multiline
          minRows={2}
          name="entry.480513445"
        />
        
        {!onDialog ? 
          <Button
            variant="contained"
            type="submit"
            endIcon={<SendIcon/>}
          >
            Enviar
          </Button>
          : ''}
      </Paper>

      <Dialog open={sended} onClose={handleClose}>
        <DialogTitle textAlign="center">{sendAlert.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{sendAlert.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>De acuerdo</Button>
        </DialogActions>
      </Dialog>

    </ScopedCssBaseline>
  </ThemeProvider>
  )
}

export default ContactForm
export {ContactFormId}